module.exports = __webpack_public_path__ + "static/media/menuWarning.93b092e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuWarning.svg
// module id = 180
// module chunks = 0